// @ts-nocheck
export const exitFullscreen = () => {
  const ele = getFullscreenElement();
  if (!ele) return;
  if (document.exitFullscreen) {
    document.exitFullscreen().catch(() => {});
  } else if (document.mozCancelFullScreen) {
    // Firefox
    document.mozCancelFullScreen().catch(() => {});
  } else if (document.webkitExitFullscreen) {
    // Chrome, Safari and Opera
    document.webkitExitFullscreen().catch(() => {});
  } else if (document.msExitFullscreen) {
    // Internet Explorer and Edge
    document.msExitFullscreen().catch(() => {});
  }
};

export const fullScreen = ele => {
  if (ele.requestFullscreen) {
    ele.requestFullscreen().catch(() => {});
  } else if (ele.mozRequestFullScreen) {
    ele.mozRequestFullScreen().catch(() => {});
  } else if (ele.webkitRequestFullscreen) {
    ele.webkitRequestFullscreen().catch(() => {});
  } else if (ele.msRequestFullscreen) {
    ele.msRequestFullscreen().catch(() => {});
  }
};

export const getFullscreenElement = () => {
  return (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullScreenElement ||
    document.webkitFullscreenElement ||
    null
  );
};
